import React, { useEffect, useState, useContext } from "react";
// import Navbar from "./global-components/navbar";
import Navbar from "./select-components/navbar-select";
import PageHeader from "./global-components/page-header";
import PropertyDetailsSection from "./section-components/property-details";
// import RecomandProperties from "./section-components/recomand-properties";
import Footer from "./select-components/footer-select";
import Viewr from "./Viewr";
// import Viewr from 'viewr'
import Spinner from "react-spinner-material";
import Loadable from "react-loadable";
import Loading from "./global-components/Loading";
import EmpresaContext from "../context";
import { isIOS, isMobile } from "../utils/util_functions";
import get from "../client_api";

const RecomandProperties = Loadable({
  loader: () =>
    import(/* webpackChunkName: "recomand-properties" */ "./section-components/recomand-properties"),
  loading: Loading,
  modules: ["recomand-properties"]
});

const PropertyDetails = ({ imovel }) => {
  const [Loading, setLoading] = useState(true);
  const [mobile, setMobile] = useState(true);
  const [viewrData, setViewrData] = useState([""]);
  let context = useContext(EmpresaContext);
  useEffect(
    () => {
      async function getViewrArray() {
        const viewrArray = await get(
          window.location.origin,
          `imovel_viewr/${imovel.db_id}`
        );
        setViewrData(viewrArray);
        console.log(viewrArray);
      }
      if (imovel.db_id) {
        setLoading(false);
      }
      getViewrArray();
      setMobile(isMobile());
    },
    [imovel]
  );

  if (Loading || !imovel.db_id) return <></>;

  let fotoDestaque = imovel.fotos.find(e => e.destaque === true);
  let imgSrc;
  let imgSrcWebp;
  try {
    imgSrc = fotoDestaque
      ? fotoDestaque.source.uri
      : imovel.fotos.sort(
          (a, b) =>
            a.destaque
              ? -1
              : parseInt(String(a.ordem)) - parseInt(String(b.ordem))
        )[0].source.uri;
    imgSrcWebp = fotoDestaque
      ? fotoDestaque.source.uri_webp
      : imovel.fotos.sort(
          (a, b) =>
            a.destaque
              ? -1
              : parseInt(String(a.ordem)) - parseInt(String(b.ordem))
        )[0].source.uri_webp;
  } catch (error) {
    console.log(error);
    imgSrc = "";
  }
  return (
    <div>
      <Navbar />
      <PageHeader
        backgroundImage={
          context.banner_imovel_default
            ? context.banner[0]
            : isIOS()
              ? imgSrc
              : imgSrcWebp || imgSrc
        }
        subheader={`${imovel.tipo} ${imovel.codigo}`}
        headertitle={
          imovel.titulo
            ? `#${imovel.codigo} ${imovel.titulo}`
            : imovel.tipo
              ? `${imovel.tipo} ${imovel.codigo}`
              : `Imóvel ${imovel.codigo}`
        }
      />
      <PropertyDetailsSection />
      <RecomandProperties
        tipo={imovel.tipo}
        transacoes={{
          venda: imovel.venda,
          locacao: imovel.locação
        }}
        precos={{
          venda: parseInt(imovel.preço_venda) || 0,
          locacao: parseInt(imovel.preço_locação) || 0
        }}
      />
      <Footer />
      {context.liberar_viewr &&
        (viewrData && viewrData.length > 0) &&
        mobile && (
          <Viewr
            urlList={viewrData
              .sort((a, b) => a.ordem - b.ordem)
              .map(video => video.url)}
          />
        )}
    </div>
  );
};

export default PropertyDetails;
